import { render, staticRenderFns } from "./HomeViewMessageData.vue?vue&type=template&id=9e51270c&scoped=true&"
import script from "./HomeViewMessageData.vue?vue&type=script&lang=js&"
export * from "./HomeViewMessageData.vue?vue&type=script&lang=js&"
import style0 from "./HomeViewMessageData.vue?vue&type=style&index=0&id=9e51270c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e51270c",
  null
  
)

export default component.exports